const getFdKeyFeatures = (fdInterestRate) => ({
    question: 'What makes our',
    title: 'FDs stand out',
    cards: [
        {
            title: 'Inflation-beating returns',
            description: `Get steady growth of up to ${fdInterestRate}`,
            icon: '/images/products/stability.svg',
            col: 'col-span-full xl:col-span-2',
        },
        {
            title: 'Flexible tenures',
            description: 'Choose from a few months to multiple years',
            icon: '/images/products/high-yield.svg',
            col: 'col-span-full xl:col-span-2',
        },
        {
            title: 'Multiple payout options',
            description: 'Get monthly/ semi-annual/ bi-annual payouts',
            icon: '/images/products/liquidity.svg',
            col: 'col-span-full xl:col-span-2',
        },
        {
            title: 'Auto-renewal',
            description:
                'Never miss out on interest - Your FD renews automatically if you set it up for renewal',
            icon: '/images/products/income.svg',
            col: 'col-span-full xl:col-span-3',
        },
        {
            title: 'Hedge against market volatility',
            description:
                "Secure your investment and don't let the market erode your returns",
            icon: '/images/products/secure.svg',
            col: 'col-span-full xl:col-span-3',
        },
    ],
});

const fdApplicationProcess = {
    question: 'Fixed Deposit ',
    title: 'application process',
    titleSuffix: '',
    cards: [
        {
            title: 'Step 1',
            description:
                'Log in to your account and select an FD of your choice',
        },
        {
            title: 'Step 2',
            description:
                'Enter your investment details including amount, tenure and nominee details',
        },
        {
            title: 'Step 3',
            description: 'Complete your KYC journey and review your inputs',
        },
        {
            title: 'Step 4',
            description:
                'Transfer the amount and complete the application process',
        },
    ],
};

const fdCarouselContent = {
    title: "Now is the right time to <br class=\"md:hidden\" /> <span class='text-primary-500'>invest in FDs</span>",
    description: 'Choose an FD of your choice',
    cards: [
        {
            name: 'Utkarsh Small Finance Bank',
            returns: '9.1%',
            icon: 'usfb',
        },
        {
            name: 'Suryoday Small Finance Bank ',
            returns: '9.1%',
            icon: 'ssfb',
        },
        {
            name: 'Shivalik SF Bank',
            returns: '9.05%',
            icon: 'ssb',
        },
        {
            name: 'North East SF Bank',
            returns: '9%',
            icon: 'nesb',
        },
        {
            name: 'Shriram Finance',
            returns: '8.97%',
            icon: 'sf',
        },
        {
            name: 'Bajaj Finance',
            returns: '8.65%',
            icon: 'bf',
        },
        {
            name: 'South Indian Bank',
            returns: '7.9%',
            icon: 'sindb',
        },
    ],
};

const fdDefaultCompareContent = {
    title: 'Compare our FD rates with the FDs in the market',
    tableData: [
        {
            bank: 'Axis Bank',
            logo: 'Axis',
            year1: '6.70% p.a.',
            year3: '7.10% p.a.',
        },
        {
            bank: 'Bandhan Bank',
            logo: 'BandhanBank',
            year1: '8.05% p.a.',
            year3: '7.25% p.a.',
        },
        {
            bank: 'Bank of Baroda',
            logo: 'Bob',
            year1: '6.85% p.a.',
            year3: '7.15% p.a.',
        },
        {
            bank: 'Central Bank of India',
            logo: 'Cbi',
            year1: '6.85% p.a.',
            year3: '7.25% p.a.',
        },
        {
            bank: 'HDFC Bank',
            logo: 'Hdfc',
            year1: '6.60% p.a.',
            year3: '7.00% p.a.',
        },
        {
            bank: 'ICICI Bank',
            logo: 'Icici',
            year1: '6.00% p.a.',
            year3: '7.00% p.a.',
        },
        {
            bank: 'IDBI Bank',
            logo: 'Idbi',
            year1: '6.80% p.a.',
            year3: '6.50% p.a.',
        },
        {
            bank: 'IDFC FIRST Bank',
            logo: 'Idfc',
            year1: '6.50% p.a.',
            year3: '6.80% p.a.',
        },
        {
            bank: 'IndusInd Bank',
            logo: 'IndusInd',
            year1: '7.75% p.a.',
            year3: '7.25% p.a.',
        },
        {
            bank: 'Karnataka Bank',
            logo: 'Kab',
            year1: '7.25% p.a.',
            year3: '6.50% p.a.',
        },
        {
            bank: 'Kotak Mahindra Bank',
            logo: 'Kmb',
            year1: '7.40% p.a.',
            year3: '7.00% p.a.',
        },
        {
            bank: 'Punjab National Bank',
            logo: 'Pnb',
            year1: '6.80% p.a.',
            year3: '7.00% p.a.',
        },
        {
            bank: 'RBL Bank',
            logo: 'Rbl',
            year1: '7.50% p.a.',
            year3: '7.50% p.a.',
        },
        {
            bank: 'South Indian Bank',
            logo: 'Sib',
            year1: '6.70% p.a.',
            year3: '6.70% p.a.',
        },
        {
            bank: 'State Bank of India',
            logo: 'Sbi',
            year1: '6.80% p.a.',
            year3: '7.00% p.a.',
        },
        {
            bank: 'Tamilnadu Mercantile Bank',
            logo: 'Tmb',
            year1: '7.00% p.a.',
            year3: '6.50% p.a.',
        },
        {
            bank: 'UCO Bank',
            logo: 'Uco',
            year1: '6.50% p.a.',
            year3: '6.30% p.a.',
        },
        {
            bank: 'Union Bank of India',
            logo: 'Ub',
            year1: '6.80% p.a.',
            year3: '6.70% p.a.',
        },
        {
            bank: 'YES Bank',
            logo: 'yes',
            year1: '7.25% p.a.',
            year3: '7.25% p.a.',
        },
    ],
    note1: 'Data as of Feb 2025. Rates are subjected to change with bank discretion',
    note2: 'Note: Senior Citizens get slightly higher interest rates ranging between 0.25% -0.50% p.a. depending on the FD tenure.',
};

const fdFAQContent = {
    title: 'Frequently Asked Questions',
    faqs: [
        {
            question: 'What Is a Fixed Deposit and How Does It Work?',
            answer: 'A fixed deposit lets you invest a lump sum for a fixed tenure at a guaranteed interest rate. You earn interest on your deposit, which compounds over time, and you receive both the principal and accumulated interest at maturity. Banks and financial institutions offer FDs as a low-risk investment option, making them ideal for achieving financial goals with certainty.',
        },
        {
            question: 'Do you need an FD in your portfolio?',
            answer: 'Even though there are a lot of other options in the market, FDs offer you guaranteed returns with lower risk. They preserve your capital, offer liquidity and predictable interest, and balance market-linked investments. Since they might not always beat inflation, you can just as conveniently use FDs for short-term goals or building emergency funds. For growth, you can diversify with some higher-yield options, but it is always a smart idea to balance your portfolio’s risk with FDs.',
        },
        {
            question:
                'What Are the Different Types of Fixed Deposit Accounts Available?',
            answer: 'Providers offer various FD types, like standard FDs with fixed returns, tax-saving FDs qualifying for Section 80C deductions, and senior citizen FDs, granting higher interest rates. Flexi FDs link to your savings account for automatic investments, while NRI FDs cater to non-resident Indians. You can choose the type that aligns with your financial objectives.',
        },
        {
            question:
                'What Is the Minimum and The Maximum Tenure for A Fixed Deposit?',
            answer: 'Fixed deposits come with tenures from 7 days to 10 years. Short-term FDs provide liquidity for immediate needs, while long-term FDs maximize returns through compounding. You should select a comfortable tenure that matches your financial goals.',
        },
        {
            question: 'What is the eligibility criteria for opening an FD?',
            answer: 'You can open an FD account as long as you are a citizen of India (resident or non-resident), any company, partnership firm, business, senior citizen or minor etc. You will need some basic documents like proof of identity, proof of address, and proof of date of birth. Please note that the detailed process and documentation can differ for different providers.',
        },
    ],
};

const fdFaqs = {
    urlId: 'fixed-deposit',
    faqs: [
        {
          question: "What is a Fixed Deposit and how does it work?",
          answer: "A fixed deposit allows you to invest a lump sum for a predetermined period at a fixed interest rate. The interest earned on your deposit compounds over time, and at maturity, you receive both the principal and interest. You can get FDs from banks and financial institutions as a low-risk investment option, to achieve your financial goals with certainty and safety."
        },
        {
          question: "Is an FD right for your portfolio?",
          answer: "Every investment asset has a different role to play in your portfolio. FDs provide guaranteed returns with minimal risk. They help preserve your capital and even grow it in volatile markets, offering liquidity and predictable interest. Large bank FDs might not always beat inflation, but they can be used conveniently for short-term goals or to build emergency funds or to cushion your portfolio from volatility. FDs from small banks and NBFCs can even help you beat inflation."
        },
        {
          question: "Is KYC mandatory for opening a Fixed Deposit?",
          answer: "Yes, KYC is mandatory for opening a Fixed Deposit account to comply with regulatory requirements and ensure the authenticity of the account holder."
        },
        {
          question: "What documents are required for KYC in Fixed Deposits?",
          answer: "You need to provide proof of identity (e.g., Aadhaar card, PAN card), proof of address (e.g., utility bill, passport), and proof of date of birth."
        },
        {
          question: "Can an FD be withdrawn partially and are there any charges for early withdrawals?",
          answer: "Most banks permit partial withdrawals from Fixed Deposits (FDs), but the terms can vary. You might face penalties, which could reduce the applicable interest rate. Some banks offer special FDs that do not have withdrawal penalties after a lock-in period. If you need liquidity, consider options like Flexi FDs or laddering your deposits. Always check the withdrawal rules before investing to avoid unexpected charges or losses."
        }
      ]
}

const fdDefaultInterestRate = '9.1%';

const isFDFeatureEnabled =
    process.env.NEXT_PUBLIC_FD_FEATURE_ENABLED === 'true';

export {
    getFdKeyFeatures,
    fdApplicationProcess,
    fdCarouselContent,
    fdDefaultCompareContent,
    fdFAQContent,
    fdDefaultInterestRate,
    isFDFeatureEnabled,
    fdFaqs
};
